/* import __COLOCATED_TEMPLATE__ from './connection-overlay.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();